module.exports = __webpack_public_path__ + "static/media/archipelago.505b7b47.png";